import { render, staticRenderFns } from "./SelectTeamRole.vue?vue&type=template&id=37fb219c&scoped=true&"
import script from "./SelectTeamRole.vue?vue&type=script&lang=js&"
export * from "./SelectTeamRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb219c",
  null
  
)

export default component.exports